/**
 * Scripts Main
 *
 * The main scripts used site wide.
 */
console.log('%c +GF+ : Main Loaded', 'font-weight: bold; background-color: #00629B; padding: 2px 2px 2px 0;');


/**
 * Import Libraries
 */
import $ from "jquery";
import _ from 'lodash';

// SWUP
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupDebugPlugin from '@swup/debug-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
//import SwupGtagPlugin from 'swup-gtag-plugin';
import SwupGaPlugin from '@swup/ga-plugin';
import SwupRouteNamePlugin from '@swup/route-name-plugin';

// GSAP
import { gsap } from "gsap";
import { GSDevTools } from "gsap/GSDevTools";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

// import Swiper JS
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Micro Modal
import MicroModal from 'micromodal';

// GF World Custom Libraries
import initLightbox from './lib/gf-lightbox';
import initTooltips from './lib/gf-tooltip';
import initInView from './lib/gf-inview';
import initScrollTop from './lib/gf-scroll-top';
import initAnimNodePulse from './lib/gf-animation-node-pulse';
import initMenuFlyOut from './lib/gf-menu-flyout';
import initWelcomePopup from './lib/gf-welcome';
import initIndustryMenuScroll from './lib/gf-mobile-menu';
import initWeather from './lib/gf-weather';
// import initSwiper from './lib/gf-swiper';



/**
 * GSAP
 * 
 * Register the plugins we need.
 */
gsap.registerPlugin(GSDevTools, MotionPathPlugin);



/**
 * SWUP
 *
 * New Swup object
 */
const swup = new Swup({
	linkSelector: 'a',
	animateHistoryBrowsing: true,
	animationScope: 'html',
	plugins: [
		new SwupBodyClassPlugin(),
		new SwupDebugPlugin(),
		new SwupGaPlugin({ gaMeasurementId: 'G-KG0NFDFCM6' }),
		// new SwupGtmPlugin(),
		new SwupRouteNamePlugin({ paths: true }),
	]
});



/**
 * Check Browser
 *
 * Checks which browser the user is in.
 */

// Get the user-agent string 
let userAgentString = navigator.userAgent;

// Detect Chrome 
let chromeAgent = userAgentString.indexOf("Chrome") > -1;

// Detect Internet Explorer 
let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;

// Detect Firefox 
let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

// Detect Safari 
let safariAgent = userAgentString.indexOf("Safari") > -1;

// Detect Opera 
let operaAgent = userAgentString.indexOf("OP") > -1;

// Discard Safari since it also matches Chrome 
if ((chromeAgent) && (safariAgent)) safariAgent = false;

// Discard Chrome since it also matches Opera      
if ((chromeAgent) && (operaAgent)) chromeAgent = false;




/**
 * jQuery
 *
 * This can get a bit screwy with scope. But for the most part it 
 * allows the use of jQuery's $ since WordPress declares noconflict() mode.
 * 
 * TODO: this should probably be removed, the $ is imported above.
 */
(function ($, root, undefined) {

	// Document ready
	$(function () {

		/**
		 * SWUP Load JS
		 * 
		 * This function is run on initial page load and on swup content replacement.
		 */
		function loadJS() {
			console.log('%c +GF+ : SWUP Load Complete', 'font-weight: bold; background-color: #00629B; padding: 2px 2px 2px 0;');

			// Check what page we are on
			const isApplicationPage = document.body.classList.contains('single-application');

			// Initialize MicroModal if modals exist
			if (document.querySelector('.micromodal-slide')) {
				MicroModal.init({
					disableScroll: true,
					disableFocus: false,
					awaitOpenAnimation: true,
					awaitCloseAnimation: true
				});
			}

			// Initialize Libraries
			initLightbox();
			initInView();
			initScrollTop();
			initAnimNodePulse();
			initMenuFlyOut();
			initWelcomePopup();
			initWeather();

			if (!isApplicationPage) {
				initTooltips();
				initIndustryMenuScroll();
			}

		}
		loadJS();

		// Cleanup swiper before content replacement
		swup.hooks.on('content:replace', () => {
			const container = document.querySelector('.gf-swiper');
			if (container && container.swiperInstance) {
				container.swiperInstance.destroy(true, true);
			}
		});

		// Reload JS on content replace
		swup.hooks.on('content:replace', loadJS);

		// Back button helper for Application pages that share multiple parents/industries
		swup.hooks.on('page:view', (visit) => {
			const from = visit?.from?.url || null;
			if (!from) return; // First load: nothing to inject

			// Inject into any element(s) you want
			document.querySelectorAll('[data-back-link]').forEach(a => {
				a.setAttribute('href', from);
			});
			document.body.dataset.swupFrom = from;
		});
	});
})(jQuery, this);


